import React from 'react';

const CONFIG = {
  TOTAL_STOCK:   { cls: 'bg-indigo-100 text-indigo-700 border border-indigo-200',  label: 'Total Stock' },
  EXPIRED_STOCK: { cls: 'bg-orange-100 text-orange-700 border border-orange-200',  label: 'Expired Stock' },
  LOW_STOCK:     { cls: 'bg-rose-100 text-rose-700 border border-rose-200',        label: 'Low Stock' },
  STOCK_SUMMARY: { cls: 'bg-teal-100 text-teal-700 border border-teal-200',        label: 'Stock Summary' },
};

export default function ReportTypeBadge({ type }) {
  const cfg = CONFIG[type] ?? { cls: 'bg-gray-100 text-gray-600 border border-gray-200', label: type };
  return (
    <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}
